import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import styles from './index.module.css';

export interface Links {
  label: string;
  to: string;
  active?: boolean;
}

export interface NavLinksProps {
  links: Links[];
}

export function NavLinks({ links }: NavLinksProps): ReactElement {
  return (
    <nav aria-label="header-nav" className="header-item">
      <ul className="tabs">
        {links.map(({ active, ...link }) => (
          <li
            key={link.label}
            className={classnames('tab', styles.tab, {
              active,
              [styles.active]: active,
            })}
          >
            <Link to={link.to} className={styles.tab}>
              <div className="tab__heading">{link.label}</div>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
